import {createReducer} from 'redux-create-reducer';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';
import {toImmutable} from "../action-creators/mutation-actions";
import {defaultComparator} from "../../utils";

const workSessionsTransform = (workSessions) => {

    const result = {};
    workSessions.sort((a, b) => defaultComparator(b[(Keys.WorkSessions.STARTED)], a[(Keys.WorkSessions.STARTED)]))
    workSessions.forEach(e => {
        result[e[Keys.ID]] = e;
    });
    return toImmutable(result);
};

export default createReducer(
    {},
    standardLoadingReducerFactory(
        Actions.GET_WORK_SESSIONS,
        Keys.StoreSliceData.WORK_SESSIONS,
        workSessionsTransform
    )
);



// WEBPACK FOOTER //
// ./src/model/reducers/work-session-reducer.js